<dp-section-form [form]="sectionForm"></dp-section-form>
<app-failed-jobs-header [notifications]="selectedNotifications" (filtersChanged)="onFilterChange($event)">
</app-failed-jobs-header>
<app-failed-jobs-table (selectedRow)="onCheckChange()" (tableLoaded)="onTableLoaded($event)" [filters]="filters"
    class="col-12">
</app-failed-jobs-table>
